import { IGetDashboardRhInformationUseCase } from "../../../presentation/useCases/read/get_dashboard_rh_information_use_case";
import { DashboardRh } from "../../models/dashboard_rh";
import { IRhRepository } from "../../repositories/rh_repository";

/**
 * GetDashboardRhInformationUseCase
 */

export class GetDashboardRhInformationUseCase implements IGetDashboardRhInformationUseCase {
  constructor(private readonly repository: IRhRepository) { }

  async getDashboardRhInformation(): Promise<DashboardRh> {
    return await this.repository.getDashboardRhInformation();
  }
}
